<template>
  <router-link
    :to="{ name: routeName }"
    class="page__logo"
    :class="{
      'page__logo--inverted': invertedColors,
      'page__logo--large': largeLogo,
    }"
  >
    <HdIcon :src="homedayLogo" :width="largeLogo ? 46 : 32" :height="largeLogo ? 46 : 32" />
    <div class="page__logo-text-wrapper">
      <span class="page__logo-appname">{{ $t('GENERAL.APP_NAME') }}</span>
      <span class="page__logo-subtitle">{{ $t('GENERAL.APP_NAME_SUBTITLE') }}</span>
    </div>
  </router-link>
</template>

<script>
import { HdIcon } from 'homeday-blocks';
import { homedayLogo } from 'homeday-assets';
import { DEALS as DEALS_ROUTES } from '@/router/wizard/ROUTE_NAMES';

export default {
  name: 'PageLogo',
  components: {
    HdIcon,
  },
  props: {
    routeName: {
      type: String,
      default: DEALS_ROUTES.INDEX,
    },
    invertedColors: {
      type: Boolean,
      default: false,
    },
    largeLogo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      homedayLogo,
      DEALS_ROUTES,
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.page__logo {
  display: flex;
  align-items: center;
  text-decoration: none;

  ::v-deep svg {
    min-width: 32px;

    path {
      fill: $primary-bg;
    }
  }

  &-text-wrapper {
    display: flex;
    flex-direction: column;
  }

  &-appname,
  &-subtitle {
    color: $primary-bg;
    margin-left: $sp-s;
  }

  &-appname {
    @include font('DS-100');
    font-weight: 700;
    line-height: 1.1;
  }

  &-subtitle {
    @include font('DS-80');
    font-weight: 600;
    line-height: 1;
  }

  &--inverted {
    .page__logo-appname,
    .page__logo-subtitle {
      color: getShade($primary-color, 110);
    }

    ::v-deep svg path {
      fill: getShade($primary-color, 110);
    }
  }

  &--large {
    margin-left: (-$sp-xxs);
    width: 180px;

    svg {
      @include for('mobile-only') {
        height: 32px;
        width: 32px;
      }
    }

    .page__logo-text-wrapper {
      width: 180px;

      @include for('mobile-only') {
        width: 145px;
      }
    }

    .page__logo-appname {
      @include for('mobile-only') {
        @include font('DS-100');
      }

      font-size: 22px;
    }
  }
}
</style>
